import Vue from 'vue'
import Vuex from 'vuex'
import VTooltip from 'v-tooltip'
import merge from 'lodash-es/merge'

import translateFilter from '@/vue/filters/translate'
import SvgIcon from '@/vue/components/svg_icon.vue'
import scrollsIntoView from '@/vue/directives/scrolls_into_view'

import { clickTrack, trackingContext } from '@/vue/directives/tracking'

import App from './components/fused/app.vue'
import storeConfig from './store/index'

Vue.component('SvgIcon', SvgIcon)
Vue.directive('tracking-context', trackingContext)
Vue.directive('click-track', clickTrack)
Vue.directive('scrolls-into-view', scrollsIntoView)

Vue.use(Vuex)
Vue.use(VTooltip)

// export a factory function for creating fresh app, router and store instances
export function createApp(initialState, I18n) {
  Vue.filter('t', translateFilter(I18n))
  const store = new Vuex.Store(storeConfig)
  // Initialize the store with the Rails Vuex Store state
  store.replaceState(merge(store.state, initialState))

  // the root instance simply renders the App component.
  const app = new Vue({ store, render: h => h(App) })

  return { app, store }
}
